<div mat-dialog-title>
	{{progressMessage}}
</div>
<div mat-dialog-content>
	<p>{{waitMessage}}</p>
	<div class="spinner-circle">
		<mat-spinner [diameter]="24"></mat-spinner>
	</div>
</div>